import { NGXAjax } from '../../common/Services/AjaxService.js';
import { resolve, reject } from './util/api-util';

function fetchSurveys() {
  return NGXAjax.get('/api/survey/list.json', {
    sort:  'id',
    order: 'desc',
    max:   -1, // param to fetch all without pagination
  }).then(resolve, reject);
}

export { fetchSurveys };
